import { Component, OnInit } from '@angular/core';
import {CrudUserService} from '@shared/services/crud-user.service';
import * as moment from 'moment';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-blocked-users',
  templateUrl: './blocked-users.component.html',
  styleUrls: ['./blocked-users.component.scss']
})
export class BlockedUsersComponent implements OnInit {

  users: any[];

  constructor(protected userCrudService: CrudUserService) {}

  ngOnInit(): void {
    this.userCrudService.getBlockedUsers().subscribe(response => {
      this.users = response.results;
    });
  }

  getUserEditLink(id) {
    return ['users/' + id + '/edit'];
  }

  unblock(id) {
    this.users = undefined;
    this.userCrudService.unblockUser(id).subscribe(e => {
      this.userCrudService.getBlockedUsers().subscribe(response => {
        this.users = response.results;
      });
    });
  }

  getTimeleft(blockedtimeexpiration: any) {
    let timeleftMessage = '';
    if (!blockedtimeexpiration) {
      timeleftMessage = 'Blocked indefinitely';
    } else {
      if (moment().unix() > moment(new Date(blockedtimeexpiration.date)).unix()) {
        timeleftMessage = 'Unblocked at next login';
      } else {
        timeleftMessage = 'Blocked until ' + moment(new Date(blockedtimeexpiration.date)).format('DD/MM HH:mm:ss');
      }
    }
    return  timeleftMessage;
  }
}
